import { Grid } from '@material-ui/core';
import './stampcard.scss';
import { PrimaryButton } from '../../../Core/FormInput';
import { postStampData } from '../../../Core/Service/stamp-screen-service';
import { set } from 'lodash';
import React from 'react';
import AppContext from '../../../App/AppContext';
import { Alert } from '@material-ui/lab';
import { useWindowSize } from '../../../Core/Controls/ScreenResolution';

const styles = {
    container: { padding: 20, display: 'flex', flexWrap: 'wrap', gap: 20 },
    card: {
        border: '1px solid #ccc',
        borderRadius: 8
    }
};

const buttons = [{ name: 'Edit' }, { name: 'Delete' }];

const CardTemplate = ({ image, object, onUpdate, onDelete }) => {
    const [width, height] = useWindowSize();
    const [showWarning, setShowWarning] = React.useState(false);
    return (
        <div style={styles.card} className="card">
            <div className="card-image">
                <img src={image} alt={'test'} onClick={width < 500 ? () => {} : () => onUpdate(object)} />
            </div>
            {!showWarning ? (
                <div className="card-footer">
                    {buttons.map((k, index) => (
                        // <div>
                        <PrimaryButton
                            size="small"
                            key={index}
                            onClick={k.name === 'Edit' ? () => onUpdate(object) : () => setShowWarning(true)}
                            style={{ margin: '5px' }}
                            variant="contained"
                            color={k.name === 'Edit' ? 'primary' : 'secondary'}
                        >
                            {k.name}
                        </PrimaryButton>
                        // </div>
                    ))}
                </div>
            ) : (
                <div className="card-footer-delete-warning">
                    Are you sure you want to delete this stamp ?
                    <div>
                        <button onClick={() => onDelete(object)}>yes</button>
                        &nbsp;
                        <button onClick={() => setShowWarning(false)}>no</button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default function StampCards({ List, onUpdate, onClose }) {
    const { showToast } = React.useContext(AppContext);
    const handleRemoveAssociations = async (data) => {
        try {
            const payload = {
                StampID: data.stampID,
                BranchIDs: []
            };
            const res = await postStampData(payload);

            if (res.success) {
                showToast('All branch associations removed');
                onClose(true);
            }
        } catch (error) {
            console.error('Deletion failed:', error);
            showToast('Delete failed');
        }
    };

    return (
        <div className="StampCard">
            {List.map((obj, index) => {
                return (
                    <div item key={index}>
                        <CardTemplate image={obj.stampImage} object={obj} onUpdate={onUpdate} onDelete={handleRemoveAssociations} />
                    </div>
                );
            })}
        </div>
    );
}
